export { MorphemeGlyphTilePinyinDot } from "#morpheme-glyph-tile-pinyin-dot";
